export default (
  state = {
    group_variables: {},
    visualizer_input_output_values: {},
    visualizer_input_output_details: {},
    logo: "",
    app_loading: true,
    should_update: false,
    query_string: {},
    extension_variables: [{}, {}],
    isPDFView: false,
    vtv_id: 0,
    PDF_JSON: [],
    updatedVariables: {},
    isDownloading: true,
    calculate: "",
    decorate: "",
    script_id: "",
    hide_outputs: true,
    checkbox: false,
    email: "",
    currency_conversion_rate: 1,
    region: "USD",
    currency_sign: "$",
  },
  action
) => {
  let Pstate = JSON.parse(JSON.stringify(state));
  switch (action.type) {
    case "Set_Query_String":
      state.query_string = action.query_string;
      state.script_id =
        action.query_string.script_id !== undefined
          ? action.query_string.script_id
          : state.script_id;
      return { ...state };
    case "Set_Script_id":
      state.script_id = action.script_id;
      return { ...state };
    case "Update_Query_String":
      console.log("update query string: ", action);
      state.query_string = action.query_string;
      return { ...state };
    case "Set_Widget_Data":
      let visualizer_input_output_values_container = Object.assign(
        {},
        action.VisualizeROI.visualizerWidget.initialData.variables
      );
      let visualizer_input_output_details_container =
        mapVisualizerInputOutputDetails(
          action.VisualizeROI.visualizerWidget.visualizerData.input,
          action.VisualizeROI.visualizerWidget.visualizerData.output
        );

      state.group_variables = JSON.parse(
        action.VisualizeROI.visualizerWidget.visualizerData.groupvariable
      );
      state.visualizer_input_output_values =
        visualizer_input_output_values_container;
      state.visualizer_input_output_details =
        visualizer_input_output_details_container;
      state.logo = action.VisualizeROI.visualizerWidget.visualizerData.logo;
      state.app_loading = false;
      state.should_update = false;
      state.extension_variables = setExtensionVariables(
        action.VisualizeROI.visualizerWidget.initialData.variables
      );
      state.vtv_id =
        action.VisualizeROI.visualizerWidget.visualizerData.visualizer_type_version_id;
      state.calculate = action.VisualizeROI.visualizerWidget.calculate;
      state.decorate = action.VisualizeROI.visualizerWidget.decorate;
      return { ...state };
    case "Set_Input_Output_Values":
      state.visualizer_input_output_values = action.calculated_values;
      return { ...state };
    case "Set_Should_Update":
      state.should_update = action.should_update;
      return { ...state };
    case "Set_Tag_Extension": {
      Pstate.tag_extension = action.tag_extension;
      window["extension_tags"] = action.tag_extension;
      return Pstate;
    }
    case "PDF_VIEW_HANDLE": {
      state.isPDFView = action.payload;
      return { ...state };
    }
    case "HANDLE_SHOW_OUTPUTS": {
      state.hide_outputs = false;
      return { ...state };
    }
    case "HANDLE_HIDE_OUTPUTS": {
      state.hide_outputs = action.payload.hide_outputs;
      state.email = action.payload.email;
      state.checkbox = action.payload.checkbox;
      return { ...state };
    }
    case "HANDLE_CHECKBOX": {
      state.checkbox = action.payload.checkbox;
      return { ...state };
    }
    case "SET_PDF_JSON": {
      state.PDF_JSON = action.payload != null ? action.payload : [];
      return { ...state };
    }
    case "SET_UPDATED_VARIABLES": {
      state.updatedVariables = action.updatedVariables;
      return { ...state };
    }
    case "SET_DOWNLOADING_FLAG": {
      state.isDownloading = action.payload;
      return { ...state };
    }
    case "CURRENCY_UPDATE": {
      console.log("CURRENCY_UPDATE");
      state.region = action.payload.temp_region;
      state.currency_sign = action.payload.currency_sign;
      state.currency_conversion_rate = action.payload.currency_conversion_rate;
      return { ...state };
    }
    default:
      return { ...state };
  }
};

function mapVisualizerInputOutputDetails(input, output) {
  let input_container: any;
  input_container = {};

  for (let key in input) {
    input_container[input[key].code_reference] = input[key];
  }

  let output_container: any;
  output_container = {};

  for (let key in output) {
    output_container[output[key].code_reference] = output[key];
  }

  return Object.assign({}, input_container, output_container);
}

function setExtensionVariables(variables) {
  let input = variables.inputs;
  let output = variables.outputs;

  // let allVars: VariablesType = {}, dataSource: Array<EnumType> = [], enmus: Array<EnumType> = [];
  let extensionVariables = [{}, {}];
  Object.keys(input).forEach((e) => {
    // let variable = input[e];
    if (!isNaN(Number(input[e]))) {
      extensionVariables[0][e] = {
        value: Number(input[e]),
        val: Number(input[e]),
      };
    } else {
      extensionVariables[0][e] = { value: input[e].value, val: input[e].value };
    }
  });
  Object.keys(output).forEach((e) => {
    // let variable = output[e];
    if (!isNaN(Number(output[e]))) {
      extensionVariables[0][e] = {
        value: Number(output[e]),
        val: Number(output[e]),
      };
    } else {
      extensionVariables[0][e] = { value: output[e], val: output[e] };
    }
  });

  return extensionVariables;
}
